export default "__VITE_ASSET__CyBXbBEg__"